<template>
  <div class="tab-pane fade active show" id="stay-average" role="tabpanel" aria-labelledby="stay-average-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option v-for="(list, index) in carFlowScenicArea" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryData"
            :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitCCTVList">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">遊客停留時間</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="stayAverage" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">風景區</th>
                    <th scope="col">日期</th>
                    <th scope="col">交通工具型態</th>
                    <th scope="col">平均停留時間</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in stayAverageData" :key="key" :class="tableCenterStyle">
                    <td>{{ key + 1 }}</td>
                    <td>{{ item.areaName }}</td>
                    <td>{{ printDate(item.sttime,item.endtime)}}</td>
                    <td>{{ getVehicleTypeName(item.vehicleType)}}</td>
                    <td>{{ item|timeFormat }}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment, { max } from "moment";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import {getStayAverageWholeInterval} from '../../api/adminDist/stayAverageApi'
export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      stayAverageData: [],
      isWaitCCTVList: false,
      maxSelectTime: moment().startOf('m').toISOString(),
    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


    carFlowScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    },

  },
  methods: {
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },
    async queryCSV() {
      this.isWaitCCTVList = true
      const stayAverageData = await this.searchData()
      if (Utils.isEmptyObject(stayAverageData)) {
        return
      }

      const selectedScenery = this.scenicAreaList.find(s => s.id === this.selectScenicAreaId)
      const scenicName = selectedScenery ? selectedScenery.name : '-'
      const csvContent = [['風景區', '日期', '交通工具型態', '平均停留時間']]
      let vm=this
      stayAverageData.forEach(item => {
        const row = []
        row.push(item.areaName)
        row.push(vm.printDate(item.sttime,item.endtime))
        row.push(vm.getVehicleTypeName(item.vehicleType))
        row.push(vm.$options.filters.timeFormat(item))

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD_HH_mm')}-${moment(this.endTime).format('YYYY/MM/DD_HH_mm')}_平均停留.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaitCCTVList = false
    },

    async queryData() {
      this.isWaitCCTVList = true
      this.stayAverageData = await this.searchData()
      this.updateTable()
      this.isWaitCCTVList = false
    },

    async searchData() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return
      }
      let areas=[];
      if (this.selectScenicAreaId === -1)areas=null
      else areas.push(this.selectScenicAreaId)

      const condition = {
        sttime:moment(this.startTime).startOf('minute').format(),
        endtime:moment(this.endTime).startOf('minute').format(),
        areas: areas
      }
      //debugger
      let stayAverageData=await getStayAverageWholeInterval(condition)
      //console.log(stayAverageData)
      return stayAverageData
    },

    initTable: function () {
      this.table = $("#stayAverage").DataTable({
        aoColumns: [
          ...new Array($("#stayAverage th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
    getVehicleTypeName(vehicleType){
      return CONST.ELK_CAR_TYPE[vehicleType];
    },
    printDate(sttime,endtime){
      return moment(sttime).format('YYYY-MM-DD')+'~'+moment(endtime).format('YYYY-MM-DD');
    }
  },
  mounted() {
    this.updateTable()
  },
  filters:{
    timeFormat:function(item){
      let timespan=item.averageStayTime;
      let days = String(timespan.days).padStart(2, '0');
      let hours = String(timespan.hours).padStart(2, '0');
      let minutes = String(timespan.minutes).padStart(2, '0');
      let seconds = String(timespan.seconds).padStart(2, '0');
      let result = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      return result;
    }
  }
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th{width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>